import { formatDistanceToNow, formatISO9075 } from 'date-fns'
import { getInLocalTime } from '../../util/timeHelpers'
import { formatShortRelativeDate } from './relativeDate'

export function StandardDateDisplay({ date }: { date: string }) {
    return date ? formatISO9075(getInLocalTime(date)) : null
}

type RelativeProps = {
    date: string
    // Responsive: renders the compact form below the `@3xl` (768px) container
    // breakpoint and the long form above it. Must sit inside a `@container`.
    // The long form is wide (about 20 characters) so it waits for 768px, well
    // past the 512px where the card's links gain their text labels.
    short?: boolean
}

export function RelativeDateDisplay({ date, short = false }: RelativeProps) {
    if (!date) {
        return null
    }
    const parsed = getInLocalTime(date)
    const long = formatDistanceToNow(parsed, { addSuffix: true })
    if (!short) {
        return <>{long}</>
    }
    return (
        <>
            <span className="@3xl:hidden">{formatShortRelativeDate(parsed)}</span>
            <span className="hidden @3xl:inline">{long}</span>
        </>
    )
}
